import React from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import {
  Box,
  VStack,
  Text,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from '@chakra-ui/react';

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: '16px',
      color: '#424770',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#9e2146',
    },
  },
};

const CardElementComponent = ({ error, setError }) => {
  const stripe = useStripe();
  const elements = useElements();

  const handleChange = (event) => {
    if (event.error) {
      setError(event.error.message);
    } else {
      setError(null);
    }
  };

  return (
    <VStack spacing={4} align="stretch">
      <Box
        p={4}
        border="1px solid"
        borderColor={error ? "red.300" : "gray.200"}
        borderRadius="md"
        bg="white"
        _focusWithin={{
          borderColor: error ? "red.500" : "blue.500",
          boxShadow: error ? "0 0 0 1px #E53E3E" : "0 0 0 1px #3182CE",
        }}
      >
        <CardElement
          options={CARD_ELEMENT_OPTIONS}
          onChange={handleChange}
        />
      </Box>
      
      {error && (
        <Alert status="error" borderRadius="md">
          <AlertIcon />
          <Box>
            <AlertTitle>Card Error</AlertTitle>
            <AlertDescription>{error}</AlertDescription>
          </Box>
        </Alert>
      )}
      
      <Text fontSize="sm" color="gray.600">
        Your payment information is secure and encrypted. We never store your card details.
      </Text>
    </VStack>
  );
};

export default CardElementComponent; 